export default "__VITE_ASSET__2f8cbdf7__"